export const SALESIQ_WIDGET_URL: string =  'https://salesiq.zohopublic.com/widget?wc=siqf513f6e297a40ad559ffe7a9dede30bcd8f34a0fdbe605db26fd1ce484097825';

  // 'https://salesiq.zohopublic.com/widget?wc=siqbf08c3f6cea5564034164647746e34f147cab389d26909dac7c31089577e9665'; // staging url

export const SALESIQ_WHATSAPP_URL: string =
  'https://wa.me/918448027888?text=Hi%20Team%2C%20I%20need%20assistance.%20Could%20you%20please%20assist%3F';

export const SALESIQ_BOOTSTRAP_SCRIPT: string =
  'window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}';

const SCRIPT_ID_BOOTSTRAP: string = 'zoho-salesiq-bootstrap';
const SCRIPT_ID_WIDGET: string = 'zsiqscript';

// Browser sessionStorage key that flags an assisted-sales session. Each app
// writes it from its own backend session; the widget skips loading when true.
export const ASSISTED_USER_STORAGE_KEY: string = 'isAssistedUser';

export type SalesIQVisitorInfo = Record<string, string>;

const MOBILE_UA_REGEX =
  /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  return MOBILE_UA_REGEX.test(navigator.userAgent);
}

export function isAssistedUserFromStorage(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(ASSISTED_USER_STORAGE_KEY) === 'true';
}

function getSalesIQReadyScript(): string {
  const whatsappUrl = SALESIQ_WHATSAPP_URL.replace(/'/g, "\\'");
  return [
    '$zoho.salesiq.ready=function(){',
    "  $zoho.salesiq.set('home.widgets',[",
    '    {',
    '      type:"action_item",',
    '      title:"WhatsApp",',
    '      icon:{type:"channel",name:"whatsapp",url:"' + whatsappUrl + '"}',
    '    }',
    '  ]);',
    '};',
  ].join('');
}

export function setSalesIQVisitorInfo(visitorInfo: SalesIQVisitorInfo): void {
  if (typeof window === 'undefined') return;
  const zoho = (window as any).$zoho;
  if (!zoho?.salesiq) return;

  const contactNumber = visitorInfo['Phone'];

  const prevReady = zoho.salesiq.ready;
  zoho.salesiq.ready = function () {
    if (typeof prevReady === 'function') prevReady();
    zoho.salesiq.visitor?.info(visitorInfo);
    if (contactNumber) zoho.salesiq.visitor?.contactnumber(contactNumber);
  };

  zoho.salesiq.visitor?.info(visitorInfo);
  if (contactNumber) zoho.salesiq.visitor?.contactnumber(contactNumber);
}

export function loadSalesIQ(): void {
  if (typeof document === 'undefined' || !document.head) return;

  const doc = document;

  if (!doc.getElementById(SCRIPT_ID_BOOTSTRAP)) {
    const bootstrap = doc.createElement('script');
    bootstrap.id = SCRIPT_ID_BOOTSTRAP;
    bootstrap.textContent = SALESIQ_BOOTSTRAP_SCRIPT + '\n' + getSalesIQReadyScript();
    doc.head.appendChild(bootstrap);
  }

  if (!doc.getElementById(SCRIPT_ID_WIDGET)) {
    const widget = doc.createElement('script');
    widget.id = SCRIPT_ID_WIDGET;
    widget.src = SALESIQ_WIDGET_URL;
    widget.defer = true;
    doc.head.appendChild(widget);
  }
}
